import { useRef, useState, type FC } from "react";
import { Button, Stack } from "@mui/material";
import { paths } from "src/paths";
import { RouterLink } from "src/components/router-link";
import { useTranslation } from "react-i18next";
import { tokens } from "src/locales/tokens";
import LoadingButton from "@mui/lab/LoadingButton";
import { Topic } from "src/types/topic";
import {
  TopicGenericEditForm,
  TopicGenericEditHandle,
} from "./topic-edit-generic-form";

interface TopicEditFormProps {
  topic: Topic;
}

export const TopicEditForm: FC<TopicEditFormProps> = (props) => {
  const { t } = useTranslation();
  const { topic } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const childRef = useRef<TopicGenericEditHandle>(null);

  return (
    <Stack spacing={4}>
      <TopicGenericEditForm
        onSubmitStatus={(isSubmitting) => {
          setIsSubmitting(isSubmitting);
        }}
        ref={childRef}
        topic={topic}
      />
      <Stack
        alignItems="center"
        direction="row-reverse"
        justifyContent="flex-end"
        spacing={1}
      >
        <Button
          href={paths.topics.list}
          color="inherit"
          component={RouterLink}
        >
          {t(tokens.general.buttons.cancel)}
        </Button>
        <LoadingButton
          type="submit"
          onClick={() => {
            childRef.current?.handleSubmit();
          }}
          disabled={isSubmitting}
          loading={isSubmitting}
          variant="contained"
        >
          {t(tokens.general.buttons.update)}
        </LoadingButton>
      </Stack>
    </Stack>
  );
};
